export interface Time {
  start: string;
  finish: string;
}
